<template>
  <div class="home">
    <Banner></Banner>
    <About></About>

    <section class="contact" id="contact">
      <div class="container">
        <h2 class="support">Support</h2>
        <p class="support-spec">
          Thank you for your interest in our apps. Please use the form below to
          ask a question, report a bug or make a suggestion.
        </p>
        <Contact />
      </div>
    </section>
  </div>
</template>

//
<script>
import Banner from "@/components/Banner/Banner";
import Contact from "@/components/Contact/Contact";
import About from "@/components/About/About";
export default {
  name: "Home",
  components: { Contact, Banner, About }
};
</script>

<style lang="scss" scoped>
.container h2,
h3,
p {
  color: #fff !important;
}
.contact {
  background: rgb(161, 189, 184);
  padding: 40px 0;
}
.support {
  font-size: 4rem;
}
.support-spec {
  margin: 24px 0;
}
</style>
